/* eslint-disable no-unused-vars */
import { defineStore } from "pinia";
import http from "../config/apiConfig";

export const useWorkCaseStore = defineStore("workCase", {
  actions: {
    async workCaseinfoFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/workCase/info/" + payload.uid;
          const response = http.get(pathUrl);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async workCaselistFetch(payload) {
      const body = {
        page: {
          index: payload.index,
          size: payload.size,
          sort: "",
        },
        filter: {
          "paymentGrp.uid": payload.paymentGrp,
          cusIdNumber: payload.cusIdNumber,
          "cusName:contains": payload.cusName,
          status: payload.status,
        },
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/workCase/list";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    // async workCaseHistoryFetch(payload) {
    //   const body = {
    //     page: {
    //       index: payload.index,
    //       size: payload.size,
    //       sort: "",
    //     },
    //     filter: {
    //       groupUid: payload.groupUid,
    //       shopUid: payload.shopUid,
    //       cusUid: payload.cusUid,
    //       refNumber: payload.refNumber,
    //       fromDate: payload.fromDate,
    //       toDate: payload.toDate,
    //       type: payload.type, // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
    //       serialNumber: payload.serialNumber, // can't combine with other filter
    //       status: payload.status, // FINISH, FREEZE, TERMINATE,
    //       txFilter: payload.txFilter, // NORMAL, MIGRATION
    //       // txFilter:
    //       //  "" : support only main type
    //       //  "NORMAL" : support only main type (PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE)
    //       //  "MIGRATION" : support only migrationType (INTEREST, INC_PRINCIPLE, DEC_PRINCIPLE)
    //       migrateRefNumber: payload.migrateRefNumber,
    //       stockNumber: payload.stockNumber,
    //     },
    //   };
    //   return new Promise((resolve, reject) => {
    //     try {
    //       const pathUrl = "/pawn-svc/workCase/history";
    //       const response = http.post(pathUrl, body);
    //       resolve(response);
    //     } catch (e) {
    //       reject(e);
    //     }
    //   });
    // },

    async workCaseHistoryFetch(payload) {
      const body = {
        page: {
          index: payload.index,
          size: payload.size,
          sort: "",
        },
        filter: {
          groupUid: payload.groupUid,
          shopUid: payload.shopUid,
          cusUid: payload.cusUid,
          stockNumber: payload.stockNumber,
          refNumber: payload.refNumber,
          fromDate: payload.fromDate,
          toDate: payload.toDate,
          txFilter: payload.txFilter, // NORMAL, MIGRATION
          // txFilter:
          //  "" : support only main type
          //  "NORMAL" : support only main type (PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE)
          //  "MIGRATION" : support only migrationType (INTEREST, INC_PRINCIPLE, DEC_PRINCIPLE)
          type: payload.type, // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
          migrateRefNumber: payload.migrateRefNumber,
          serialNumber: payload.serialNumber,
          status: payload.status, // FINISH, FREEZE, TERMINATE,BREAKING
          active: payload.active, // true: only active workCase, false: all workCases
        },
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-rpt-svc/workCase/history";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async workCaseListChainFetch(payload) {
      const body = {
        page: {
          index: payload.index,
          size: payload.size,
          sort: "",
        },
        filter: {
          workCaseUid: payload.uid,
          shopUid: payload.shopUid,
        },
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/workCase/list/chain";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async workCasenewFetch(payload) {
      const body = {
        paymentGroupUid: payload.paymentGroupUid,
        transactionType: payload.transactionType, // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
        tkVolNo: payload.tkVolNo,
        tkNo: payload.tkNo,
        tkRefNumber: payload.tkRefNumber, // from scan input when transaction type = INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
        chainUid: payload.chainUid,
        customerInfo: {
          customerUid: payload.customerUid,
          idType: payload.idType, // CITIZEN_ID, SSO_ID, PASSPORT, TAX_ID
          idNumber: payload.idNumber,
          name: payload.name,
          address: payload.address,
        },
        fpImageUid: payload.fpImageUid,
        shopInfo: {
          name: payload.name,
          license: payload.license,
          address: payload.address,
        },
        remark: payload.remark,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/workCase/new";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async workCaseupdateFetch(payload) {
      const body = {
        uid: payload.uid,
        ticket: payload.ticket,
        interestUid: payload.interestUid,
        promotionUid: payload.promotionUid,
        interestRef: payload.interestRef,
        interestCalc: payload.interestCalc,
        interest: payload.interest,
        roundInterest: payload.roundInterest,
        incPrinciple: payload.incPrinciple,
        decPrinciple: payload.decPrinciple,
        newPawnValue: payload.newPawnValue,
        totalPay: payload.totalPay,
        totalReceive: payload.totalReceive,
        diffValue: payload.diffValue,
        pawnValue: payload.pawnValue,
        interestPerMonth: payload.interestPerMonth,
        dueDate: payload.dueDate,
        trayId: payload.trayId,
        migrateRefNumber: payload.migrateRefNumber,
        remark: payload.remark,
        version: payload.version,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/workCase/update";
          const response = http.put(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async updateTicketRelatedCusFetch(payload) {
      const body = {
        ticketUid: payload.ticketUid,
        relatedCusUid: payload.relatedCusUid,
        relatedCusName: payload.relatedCusName,
        version: payload.version,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/workCase/update/related/customer";
          const response = http.put(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async updateFPImageFetch(payload) {
      const body = {
        workCaseUid: payload.workCaseUid,
        fpImageUid: payload.fpImageUid,
        version: payload.version,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/workCase/update/fpImage";
          const response = http.put(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async updatePriorityCatFetch(payload) {
      const body = {
        ticketUid: payload.ticketUid,
        catUid: payload.catUid,
        catCode: payload.catCode,
        catName: payload.catName,
        version: payload.version,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/workCase/update/priority";
          const response = http.put(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async workCaseDeleteFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/workCase/delete/" + payload.uid;
          const response = http.delete(pathUrl);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async addRelatedCustomerFetch(payload) {
      const body = {
        workCaseUid: payload.workCaseUid,
        rlCustomerInfo: {
          // if exist in previous workcase
          customerUid: payload.customerUid,
          idType: payload.idType,
          idNumber: payload.idNumber,
          name: payload.name,
          age: payload.age,
          address: payload.address,
          issueAt: payload.issueAt,
          issueDate: payload.issueDate,
          expiryDate: payload.expiryDate,
          lifetime: payload.lifetime,
          province: payload.province,
          district: payload.district,
          subDistrict: payload.subDistrict,
          country: payload.country,
        },
        version: payload.version,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/workCase/rlCus/add";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async deleteRelatedCustomerFetch(payload) {
      const body = {
        workCaseUid: payload.workCaseUid,
        version: payload.version,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/workCase/rlCus/delete";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async workCaseinfoByScanFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/workCase/info/scan/" + payload.refNumber;
          const response = http.get(pathUrl);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async workCaseinfoAdminFetch(payload) {
      const body = {
        shopUid: payload.shopUid, // for platform
        uid: payload.uid,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/workCase/admin/info";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
  },
});
